const paymentDe = {
    "billing": {
        "name": "Name/Firmenname",
        "country": "Land",
        "postal_code": "Postleitzahl",
        "city": "Stadt",
        "address": "Adresse",
        "tax_number": "Steuernummer",
        "phone": "Telefonnummer",
        "tax_number_helper_text": "Für Unternehmen erforderlich, für Privatpersonen nicht erforderlich.",
        "billing_info": "Abrechnungsdaten",
        "emails_helper_text": "Optional. Bei mehreren E-Mail-Adressen trennen Sie diese bitte durch Kommas."
    },
    "subscription_plans": {
        "PRO": "Pro-Tarif",
        "FREE": "Kostenloser Plan"
    },
    "plan_descriptions": {
        "PRO": "Für Restaurants, die ihr Geschäft auf die nächste Stufe heben möchten! Übersetzen Sie Ihre Speisekarte mit wenigen Klicks in neue Sprachen, bitten Sie Ihre Gäste um Feedback zu ihren Gerichten, verfolgen Sie die Nutzung Ihrer QR-Code-Speisekarte mit nützlichen Statistiken oder lassen Sie QuickPick AI automatisch in Ihrem Stil auf das Feedback Ihrer Gäste antworten!",
        "FREE": "Für Restaurants, die mit Online-Speisekarten und QR-Codes starten möchten."
    },
    "subscription_status": {
        "ACTIVE": "Aktiv",
        "CANCELLED": "Abgesagt"
    },
    "next_billing_date": "Nächster Abrechnungstag",
    "current_subscription": "Aktuelles Abonnement",
    "cancel": "Stornieren",
    "subscription_interval_prices": {
        "MONTHLY": "Monat",
        "YEARLY": "Jahr",
        "HALF_YEARLY": "Halbjahr",
        "QUARTERLY": "Quartal"
    },
    "subscription_interval_payment_name": {
        "MONTHLY": "Monatsabonnement",
        "YEARLY": "Jahresabonnement",
        "HALF_YEARLY": "Halbjahresabonnement",
        "QUARTERLY": "Vierteljahresabonnement"
    },
    "reactivate": "Reaktivieren",
    "valid_to": "Gültig bis",
    "payments_and_invoices": "Zahlungen und Rechnungen",
    "amount": "Menge",
    "invoice": "Rechnung",
    "update_card": "Aktualisieren",
    "payment_method": "Zahlungsmethode",
    "cancel_subscription_confirmation": "Möchten Sie Ihr aktuelles Abonnement wirklich kündigen?",
    "cancel_subscription_valid_until": "Das Abonnement bleibt bis zum folgenden Datum gültig.",
    "subscription_cancelled": "Abonnement erfolgreich gekündigt",
    "reactivate_confirmation": "Möchten Sie das gekündigte Abonnement wirklich reaktivieren?",
    "reactivate_successful": "Abonnement erfolgreich reaktiviert",
    "change_payment_method": "Zahlungsmethode ändern",
    "change_payment_method_tooltip": "Um Ihre Zahlungsdaten zu ändern, müssen Sie die nächste Abonnementperiode bezahlen. Ihr Abonnement verlängert sich dadurch selbstverständlich um die Dauer der Periode, und die nächste Abrechnung erfolgt zum gleichen Zeitpunkt.",
    "amount_to_be_paid": "Zu zahlender Betrag",
    "new_subscription_valid_until": "Gültigkeit des neuen Abonnements",
    "bank_card_expires_soon": "Die für das Abonnement verwendete Bankkarte läuft demnächst ab.",
    "reactivate_subscription_confirmation": "Möchten Sie das gekündigte Abonnement wirklich reaktivieren?",
    "billing_information": "Abrechnungsdaten",
    "edit_billing_information": "Rechnungsinformationen bearbeiten",
    "no_available_invoices": "Es sind keine Rechnungen verfügbar",
    "subscribe": "Abonnieren",
    "continue_to_payment": "Weiter zur Zahlung",
    "confirm_subscription": "Abonnement bestätigen",
    "subscription_page_title": "Jetzt abonnieren",
    "pay": "Zahlung",
    "available_plans": "Verfügbares Abonnement",
    "accept_terms_and_conditions": "Ich habe die <a>Allgemeinen Geschäftsbedingungen</a> gelesen und akzeptiere sie.",
    "accept_recurring_payments": "Mit der Zahlung stimme ich der automatischen Abbuchung wiederkehrender Beträge zu, die ich jederzeit kündigen kann.",
    "accept_privacy_policy": "Ich habe die <a>Datenschutzrichtlinie</a> gelesen und akzeptiere sie.",
    "subscribe_soon": "Demnächst verfügbar"
};

export default paymentDe;
